/**
 * Main template.
 */
import Description from '@components/sections/description/description';
import Empty from '../../empty';
import Rails from '../../../sections/rails/ui/rails';
import Sliders from '@components/sections/sliders/ui/sliders';
import MainContext from '@shared/components/utils/context/mainContext';
import MainProps from '@shared/types/props/main';
import useMain from '../lib/useMain';

/**
 * Main template that renders Sliders, Description and Rails.
 */
export default function MainTemplate(props: MainProps) {
  const context = useMain(props);
  if (context.config.display.message) {
    return <Empty message={props.message} />;
  }
  return (
    <MainContext.Provider value={context}>
      <Sliders />
      <Description />
      <Rails />
    </MainContext.Provider>
  );
}
